import Colors from "./Colors"
import Fonts from "./Fonts"

export { Fonts }
